import styled from "styled-components";

export const Container = styled.div.attrs({})`
  height: 361px;
  min-width: 467px;
  width: 100%;

  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 0px 28px 0px 28px;
  border-radius: 14px;

  & > div:last-child {
    border-bottom: none;
  }
`;

export const Row = styled.div.attrs({})`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px 12px 0px;

  border-bottom: 1px solid #DCD6E5;
`;

export const TextNameContainer = styled.div.attrs({})`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 13px;
`;

export const TextName = styled.p.attrs({})`
  width: 120px;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.colors.text};
  margin-bottom: 0px;
`;

export const TextValue = styled.p.attrs({})`
  font-size: 18px;
  margin-bottom: 0;
  color: black;
`;


export const LabelContainer = styled.div.attrs({})`
  background-color: #FEF2EA;
  color: #BA5A1D;
  font-size: 10px;
  font-weight: 500;

  border-radius: 8px;
  padding: 3px 7px;
`;